import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import '../css/nav.css';

export function Nav() {
    const { t, i18n } = useTranslation();
    const location = useLocation();
    const currentLang = i18n.language || 'en';
    const [mobileMenu, setMobileMenu] = useState(false);
    const [langMenu, setLangMenu] = useState(false)

    const changeLanguage = (lng) => {
        const path = location.pathname.replace(/^\/(en|es)/, `/${lng}`);
        window.location.href = path;
    };

    function mobileMenuView() {
        setMobileMenu(prevState => !prevState);
    }

    function langDropdown() {
        setLangMenu(prevState => !prevState);
    }

    const buildLink = (path) => `/${currentLang}${path}`;

    return (
        <>
            <div className="nav">
                <div className="nav-wrap">
                    <Link to={buildLink('/home')} className="logo">
                        <img src="../img/parla-logo-368-x-74.png" alt={t('logo_alt')} />
                    </Link>
                    <div className="group-top-rhs-menu">
                        <div className="nav-items">
                            <Link to={buildLink('/why')}>{t('nav.why_parla')}</Link>
                            {/* <div className="platform-dropdown">
                                <div className="nav-items-dropdown">{t('nav.products')}<i className="fas fa-sort-down"></i></div>
                                <div className="dropdown-content">
                                    <Link to={buildLink('/parla-connect')} className="dropdown-item">{t('nav.products_submenu.parla-connect')}</Link>
                                    <Link to={buildLink('/parla-booking')} className="dropdown-item">{t('nav.products_submenu.parla-booking')}</Link>
                                    <Link to={buildLink('/parla-suite')} className="dropdown-item">{t('nav.products_submenu.parla-suite')}</Link>
                                </div>
                            </div> */}
                            <div className="platform-dropdown">
                                <div className="nav-items-dropdown">{t('nav.platform')}<i className="fas fa-sort-down"></i></div>
                                <div className="dropdown-content">
                                    <Link to={buildLink('/sell-from-anywhere')} className="dropdown-item">{t('nav.platform_submenu.sell_from_anywhere')}</Link>
                                    <Link to={buildLink('/connect-all-channel')} className="dropdown-item">{t('nav.platform_submenu.connect_on_any_channel')}</Link>
                                    <Link to={buildLink('/appointment-booking')} className="dropdown-item">{t('nav.platform_submenu.appointment_booking')}</Link>
                                    <Link to={buildLink('/analytics-insigths')} className="dropdown-item">{t('nav.platform_submenu.analytics_insights')}</Link>
                                    <Link to={buildLink('/payment')} className="dropdown-item">{t('nav.platform_submenu.payments')}</Link>
                                </div>
                            </div>
                            {/* <Link to={buildLink('/pricing')}>{t('nav.pricing')}</Link> */}
                        </div>
                    </div>
                    <div className="nav-rhs">
                        <div className="language-dropdown">
                            <button className="dropdown-button">
                                <img src={`/img/flags/${currentLang === 'en' ? 'united-kingdom' : 'spain'}.png`} className="flag" alt={t(`language_alt.${currentLang}`)} />
                                <i className="fas fa-sort-down"></i>
                            </button>
                            <div className="dropdown-content">
                                <div onClick={() => changeLanguage('en')} className="dropdown-item">
                                    <img src="/img/flags/united-kingdom.png" className="uk flag" alt={t('language_alt.uk')} />
                                    {t('language.english')}
                                </div>
                                <div onClick={() => changeLanguage('es')} className="dropdown-item">
                                    <img src="/img/flags/spain.png" className="es flag" alt={t('language_alt.es')} />
                                    {t('language.spanish')}
                                </div>
                            </div>
                        </div>
                        {/* <Link to="https://admin.parla.tech/signup" className="btn btn-dark">{t('nav.signup')}</Link>
                        <Link to="https://admin.parla.tech" className="btn btn-pink">{t('nav.login')}</Link> */}
                    </div>

                </div>
            </div>

            <div className="nav-mobile">
                <div className="nav-mobile-header">
                    <Link to={buildLink('/home')} className="logo">
                        <img src="../img/parla-logo-368-x-74.png" alt={t('logo_alt')} />
                    </Link>
                    <div className='nav-mobile-rhs'>
                        <div className="language-dropdown">
                            <button className="dropdown-button" onClick={langDropdown}>
                                <img src={`/img/flags/${currentLang === 'en' ? 'united-kingdom' : 'spain'}.png`} className="flag" alt={t(`language_alt.${currentLang}`)} />
                                <i className="fas fa-sort-down"></i>
                            </button>
                            {langMenu &&
                                <div className="dropdown-content">
                                    <div onClick={() => changeLanguage('en')} className="dropdown-item">
                                        <img src="/img/flags/united-kingdom.png" className="uk flag" alt={t('language_alt.uk')} />
                                        {t('language.english')}
                                    </div>
                                    <div onClick={() => changeLanguage('es')} className="dropdown-item">
                                        <img src="/img/flags/spain.png" className="es flag" alt={t('language_alt.es')} />
                                        {t('language.spanish')}
                                    </div>
                                </div>
                            }
                        </div>

                        <div className="burger-menu">
                            <div className="burger-btn" onClick={mobileMenuView}>
                                <img src='/img/Menu_Icon.svg' />
                            </div>
                        </div>


                    </div>

                </div>
                {mobileMenu &&
                    <div className="nav-mobile-body" id="nav-mobile-body">
                        <Link to={buildLink('/why')}>{t('nav.why_parla')}</Link>
                        <Link to={buildLink('/sell-from-anywhere')} className="dropdown-item">{t('nav.platform_submenu.sell_from_anywhere')}</Link>
                        <Link to={buildLink('/connect-all-channel')} className="dropdown-item">{t('nav.platform_submenu.connect_on_any_channel')}</Link>
                        <Link to={buildLink('/appointment-booking')} className="dropdown-item">{t('nav.platform_submenu.appointment_booking')}</Link>
                        <Link to={buildLink('/analytics-insigths')} className="dropdown-item">{t('nav.platform_submenu.analytics_insights')}</Link>
                        <Link to={buildLink('/payment')} className="dropdown-item">{t('nav.platform_submenu.payments')}</Link>
                        {/* <Link to={buildLink('/pricing')}>{t('nav.pricing')}</Link> */}
                        {/* <div className='menu-btn-wrap'>
                            <Link to="https://admin.parla.tech" className="btn btn-pink">{t('nav.login')}</Link>
                            <Link to="https://admin.parla.tech/signup" className="btn btn-dark">{t('nav.signup')}</Link>
                        </div> */}
                    </div>}
            </div>
        </>
    );
}
